/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Add_SubmitInputs */

const en_quick_add_submit = /** @type {(inputs: Quick_Add_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const de_quick_add_submit = /** @type {(inputs: Quick_Add_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Quick_Add_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_submit = /** @type {((inputs?: Quick_Add_SubmitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_SubmitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_submit(inputs)
	return en_quick_add_submit(inputs)
});